import { render, staticRenderFns } from "./trade-mp.vue?vue&type=template&id=23ef4ba8&scoped=true&"
import script from "./trade-mp.vue?vue&type=script&lang=js&"
export * from "./trade-mp.vue?vue&type=script&lang=js&"
import style0 from "./trade-mp.vue?vue&type=style&index=0&id=23ef4ba8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ef4ba8",
  null
  
)

export default component.exports